<template>
  <div class="userinfo-container">
    <el-form :inline="true" :model="filters">
      <el-form-item>
        <el-input
          size="small"
          v-model="filters.search"
          placeholder="关键字"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" v-on:click="queryAll"
          >查询</el-button
        >
        <el-button size="small" type="success" v-on:click="handleCreate"
          >添加</el-button
        >
      </el-form-item>
    </el-form>
    <div class="tabs-container">
      <el-tabs v-model="filters.adSpace" @tab-click="typeChange">
        <el-tab-pane
          v-for="tab in tabs"
          :key="tab.key"
          :name="tab.key"
          :label="tab.name"
        >
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-table border :data="datas" style="width: 100%" size="small">
      <el-table-column
        prop="Order"
        sortable
        label="显示序号"
        width="120"
      ></el-table-column>
      <el-table-column
        prop="Tenant.Name"
        label="企业名称"
        min-width="150"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="广告图片" width="150">
        <template slot-scope="scope">
          <viewer v-if="scope.row.Image">
            <img
              v-if="scope.row.Image"
              :src="baseUrl + scope.row.Image"
              :key="scope.row.Image"
              style="height: 40px"
            />
          </viewer>
        </template>
      </el-table-column>
      <el-table-column prop="Enable" label="启用" width="150">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.Enable"
            @change="doSave(scope.row)"
            active-color="#13ce66"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column
        prop="Desc"
        label="广告备注"
        show-overflow-tooltip
        min-width="300"
      ></el-table-column>
      <el-table-column prop="InsertTime" sortable label="创建时间" width="130">
        <template slot-scope="scope">
          {{ format.dateTimeFormat(scope.row.InsertTime) }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="handleUpdate(scope.row)"
            >修改</el-button
          >
          <el-button
            v-if="scope.row.Type != 0"
            type="text"
            @click="handleRemove(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="pageSizesList"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
        :current-page.sync="pageIndex"
      ></el-pagination>
    </div>
    <div v-if="formVisible">
      <el-dialog
        v-dragDialog
        :title="formTitle"
        :visible.sync="formVisible"
        width="600px"
        :close-on-click-modal="false"
      >
        <el-form
          :model="dataForm"
          ref="dataForm"
          label-width="110px"
          :rules="dataFormRules"
        >
          <el-form-item label="广告企业" prop="Tenant">
            <tenantSelector ref="tenantSelector" v-model="dataForm.Tenant" />
          </el-form-item>
          <el-form-item label="显示序号：" prop="Order">
            <el-input-number
              v-model="dataForm.Order"
              auto-complete="off"
              placeholder="请输入显示序号"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="上传图片：" prop="Image">
            <img
              v-if="dataForm.Image"
              :src="baseUrl + dataForm.Image"
              style="height: 80px"
            />
            <el-button
              class="submit-btn"
              type="warning"
              size="mini"
              @click="selectFile"
              >点此上传</el-button
            >
          </el-form-item>
          <el-form-item label="备注：" prop="Desc">
            <el-input
              v-model="dataForm.Desc"
              auto-complete="off"
              placeholder="请输入备注"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="formVisible = false">取消</el-button>
          <el-button type="primary" @click="handleSubmit">提交</el-button>
        </div>
      </el-dialog>
    </div>
    <fileUploadNoUI ref="fileUploadNoUI" @uploadSuccess="uploadSuccess" />
  </div>
</template>
  <script>
import { getPageList, save, del } from "@/api/business/ad.js";
import { getAll } from "@/api/business/category";
import tenantSelector from "@/components/tenantSelector.vue";
import fileUploadNoUI from "@/components/fileUploadNoUI";
export default {
  components: { tenantSelector, fileUploadNoUI },
  data() {
    return {
      datas: [],
      filters: {
        search: "",
        adSpace: "HomePage",
      },
      options: [],
      tabs: [],
      pageIndex: 1,
      pageSize: 10,
      pageSizesList: [10, 15, 20, 30, 50],
      totalCount: 0,
      formVisible: false,
      formTitle: "创建",
      dataForm: {},
      dataFormRules: {
        Tenant: [
          { required: true, message: "请选择广告企业", trigger: "change" },
        ],
        Order: [{ required: true, message: "显示序号", trigger: "change" }],
        Image: [
          { required: true, message: "请上传广告图片", trigger: "change" },
        ],
      },
    };
  },
  methods: {
    typeChange() {
      this.queryAll();
    },
    queryAll() {
      let param = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        search: this.filters.search,
        adSpace: this.filters.adSpace,
        status: "",
      };
      getPageList(param).then((res) => {
        this.datas = res.Items;
        this.totalCount = res.Total | res.Items.length;
      });
    },
    doSave(row) {
      save(row).then((res) => {
        if (res) {
          this.msg.successMsg("保存成功！");
        }
      });
    },
    handleCreate() {
      this.formTitle = "新增";
      this.dataForm = { AdSpace: this.filters.adSpace, Order: 0, Image: "" };
      this.formVisible = true;
    },
    handleUpdate(row) {
      this.formTitle = "修改";
      this.dataForm = Object.assign({}, row); // copy obj
      this.formVisible = true;
    },
    selectFile() {
      this.$refs.fileUploadNoUI.chooseFile();
    },
    uploadSuccess(val) {
      debugger;
      this.dataForm.Image = val.Path;
    },
    handleSubmit() {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          let param = JSON.parse(JSON.stringify(this.dataForm));
          save(param).then((res) => {
            if (res) {
              this.formVisible = false;
              this.queryAll();
            }
          });
        }
      });
    },
    handleRemove(row) {
      this.$confirm("确定删除吗？", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let param = {
          key: row.Key,
        };
        del(param)
          .then((res) => {
            if (res) {
              this.queryAll();
            }
          })
          .catch((ex) => {});
      });
    },
    statusChange(row) {
      save(row).then((res) => {
        if (res) {
          this.queryAll();
          this.msg.successMsg("操作成功！");
        }
      });
    },
    handleSizeChange(val) {
      var pageSize = `${val}`;
      this.pageIndex = 1;
      this.pageSize = parseInt(pageSize);
      this.$nextTick(() => this.queryAll());
    },
    handleCurrentChange(val) {
      this.pageIndex = `${val}`;
      this.queryAll();
    },
  },
  mounted() {
    this.tabs = this.$config.adSpace;
    this.queryAll();
  },
};
</script>
  <style lang='scss' scoped>
.userinfo-container {
  padding: 10px;
}
/deep/.el-dialog {
  margin-top: 10px !important;
}
</style>